/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import CommonModalChart from '../CommonModalChart';
import { chartColor } from 'asserts/styles/colors';
import { useAtomValue } from 'jotai';
import productAtom from 'atom/productAtom';
import useGetEachData from 'hooks/useGetEachData';

interface PostureModalProps {
  detailData: any;
  rightDetailData?: any;
  selectedChartType: string | null;
  labels: string[];
  isTwoChart: boolean;
  isTwoLabel?: boolean;
  rightDetailType?: string | null;
}

const RomModal = ({
  labels,
  detailData,
  rightDetailData,
  selectedChartType,
  rightDetailType,
  isTwoChart
}: PostureModalProps) => {
  const { graphYellow, graphBlue, graphOrange, graphGreen } = chartColor;
  const colors = [graphBlue, graphYellow];

  let propsData = null;
  let rightPropsData = null;

  for (const key in detailData) {
    if (key === selectedChartType) {
      propsData = detailData[key];
      break;
    }
  }

  for (const key in rightDetailData) {
    if (key === rightDetailType) {
      rightPropsData = rightDetailData[key];
      break;
    }
  }

  const [activeTab, setActiveTab] = useState(0);
  const [rightLabel, setRightLabel] = useState(false);

  const productNumber = useAtomValue(productAtom);

  const propsDataTotal = rightLabel
    ? [rightPropsData.normal.total, rightPropsData.caution.total]
    : [propsData.normal.total, propsData.caution.total];

  const eachPropsData = rightLabel
    ? [rightPropsData.normal, rightPropsData.caution]
    : [propsData.normal, propsData.caution];

  const { statsDifferentProductNumber, extractedActiveData, extractedLabels } =
    useGetEachData(productNumber, eachPropsData, activeTab);

  const dataTypes = [
    {
      title: statsDifferentProductNumber[0].value,
      data: extractedActiveData[0],
      label: extractedLabels[0],
      color: graphGreen
    },
    {
      title: statsDifferentProductNumber[1].value,
      data: extractedActiveData[1],
      label: extractedLabels[1],
      color: graphBlue
    }
  ];

  if (productNumber === 4 || productNumber === 5) {
    const thirdResult = [
      {
        title: statsDifferentProductNumber[2].value,
        data: extractedActiveData[2],
        label: extractedLabels[2],
        color: graphOrange
      }
    ];

    dataTypes.push(...thirdResult);
  }

  const data = {
    labels,
    datasets: [
      {
        data: propsDataTotal,
        backgroundColor: colors,
        borderColor: colors,
        cutout: '65%'
      }
    ]
  };

  return (
    <CommonModalChart
      labels={labels}
      dataTypes={dataTypes}
      isTwoLabel
      data={data}
      setRightLabel={setRightLabel}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      isTwoChart={isTwoChart}
    />
  );
};

export default RomModal;
